<script setup>
import { reactiveOmit } from "@vueuse/core";
import { TabsContent } from "reka-ui";
import { cn } from "@/lib/utils";

const props = defineProps({
  value: { type: [String, Number], required: true },
  forceMount: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, "class");
</script>

<template>
  <TabsContent
    :class="
      cn(
        'vf-mt-2 vf-ring-offset-background focus-visible:vf-outline-none',
        'focus-visible:vf-ring-2 focus-visible:vf-ring-ring focus-visible:vf-ring-offset-2',
        props.class
      )
    "
    v-bind="{ ...delegatedProps, ...$attrs }"
  >
    <slot />
  </TabsContent>
</template>
